import DataGrid from 'components/DataGrid';
import LoadingScreen from 'components/LoadingScreen';
import React, { Suspense, useState } from 'react';

import { useFindingDataConfig } from './PCFindingsDataGrid.config';
import PCNotesModal from './PCNotesModal';

const PCFindingsDataGrid = () => {
  const [isNotesModalOpen, setIsNotesModalOpen] = useState(false);
  const [notesData, setNotesData] = useState({
    id: 0,
    title: '',
    haveUnreadNotes: false,
  });

  const openNotesModal = (rowData) => {
    setNotesData({
      id: rowData.id,
      title: rowData.control_statement,
      haveUnreadNotes: rowData.total_notes > 0 && rowData.unread_notes > 0,
    });
    setIsNotesModalOpen(true);
  };

  const { config, data, loading } = useFindingDataConfig(openNotesModal);

  return (
    <>
      <Suspense fallback={<LoadingScreen />}>
        <DataGrid config={config} data={data} loading={loading} />
      </Suspense>
      {/* Notes Modal Component : Has to be here due to unread notes filter modal close issue */}
      {isNotesModalOpen && (
        <PCNotesModal
          toggle={() => setIsNotesModalOpen(!isNotesModalOpen)}
          postureId={notesData.id}
          title={notesData.title}
          haveUnreadNotes={notesData.haveUnreadNotes}
        />
      )}
    </>
  );
};

export default PCFindingsDataGrid;
